import { render, staticRenderFns } from "./DetailBLog1.vue?vue&type=template&id=947813b4&"
import script from "./DetailBLog1.vue?vue&type=script&lang=js&"
export * from "./DetailBLog1.vue?vue&type=script&lang=js&"
import style0 from "./DetailBLog1.vue?vue&type=style&index=0&id=947813b4&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('947813b4')) {
      api.createRecord('947813b4', component.options)
    } else {
      api.reload('947813b4', component.options)
    }
    module.hot.accept("./DetailBLog1.vue?vue&type=template&id=947813b4&", function () {
      api.rerender('947813b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PageChild/DetailBLog1.vue"
export default component.exports